import gql from 'graphql-tag';

/**
 * Types officially recognized by the Save API.
 */
export const savedProductTypes = {
  COURSE: 'PRODUCT_TYPE_COURSE',
  SPECIALIZATION: 'PRODUCT_TYPE_SPECIALIZATION',
  GUIDED_PROJECT: 'PRODUCT_TYPE_GUIDED_PROJECT',
  PROFESSIONAL_CERTIFICATE: 'PRODUCT_TYPE_PROFESSIONAL_CERTIFICATE',
  MASTERTRACK: 'PRODUCT_TYPE_MASTERTRACK',
  DEGREE: 'PRODUCT_TYPE_DEGREE',
  INVALID: 'PRODUCT_TYPE_INVALID',
} as const;

export type SavedProductStringTypes = (typeof savedProductTypes)[keyof typeof savedProductTypes];

export type Product = {
  product_id: string;
  product_type: SavedProductStringTypes;
};

export type FindSavedProductsByListOfProductsQueryVariables = {
  product: Product[];
};

/* eslint-disable graphql/template-strings */
export const SaveProductQuery = gql`
  query SaveProductQuery($input: SimpleProductRequestQueryVariables!) {
    SaveProductResponse(input: $input)
      @rest(
        type: "SaveProductResponse"
        path: "grpc/discoverybehaviors/savedproducts/v1beta1/SavedProductsAPI/SaveProduct"
        method: "POST"
      ) {
      SaveProductResponse
    }
  }
`;

/* eslint-disable graphql/template-strings */
export const DeleteSavedProductQuery = gql`
  query DeleteSavedProductQuery($input: SimpleProductRequestQueryVariables!) {
    DeleteSavedProductResponse(input: $input)
      @rest(
        type: "DeleteSavedProductResponse"
        path: "grpc/discoverybehaviors/savedproducts/v1beta1/SavedProductsAPI/DeleteSavedProduct"
        method: "POST"
      ) {
      DeleteSavedProductResponse
    }
  }
`;

/* eslint-disable graphql/template-strings */
export const GetSavedProductsQuery = gql`
  query GetSavedProductsQuery($input: SimpleProductRequestQueryVariables!) {
    GetSavedProductsResponse(input: $input)
      @rest(
        type: "GetSavedProductsResponse"
        path: "grpc/discoverybehaviors/savedproducts/v1beta1/SavedProductsAPI/GetSavedProducts"
        method: "POST"
      ) {
      savedProduct
      nextPageToken
      totalSize
    }
  }
`;

/* eslint-disable graphql/template-strings */
export const IsProductSavedQuery = gql`
  query IsProductSavedQuery($input: SimpleProductRequestQueryVariables!) {
    IsProductSavedResponse(input: $input)
      @rest(
        type: "IsProductSavedResponse"
        path: "grpc/discoverybehaviors/savedproducts/v1beta1/SavedProductsAPI/IsProductSaved"
        method: "POST"
      ) {
      isSavedProduct
    }
  }
`;
